import {ErrorHandler, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SessaoService} from './sessao/sessao.service';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {PossuiPermissoesService} from './sessao/possui-permissoes.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {DateTypeInterceptor} from './http-interceptor/datetype-interceptor/datetype-interceptor';
import {
  CredentialsInterceptor,
  SEGURANCA_CONFIGURATION,
  SegurancaConfiguration
} from './http-interceptor/credentials-interceptor/credentials-interceptor.service';
import {MensagemErrorHandlerService} from './error-handler/mensagem-error-handler.service';
import {TranslateService} from '@ngx-translate/core';
import {MensageriaService} from '@main-class/componentes/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatSnackBarModule,
  ],
})
export class SegurancaModule {
  static forRoot(config: SegurancaConfiguration): ModuleWithProviders<SegurancaModule> {
    return {
      ngModule: SegurancaModule,
      providers: [
        {
          provide: SEGURANCA_CONFIGURATION,
          useValue: config
        },
        SessaoService,
        PossuiPermissoesService,
        {
          provide: ErrorHandler,
          useClass: MensagemErrorHandlerService,
          deps: [MensageriaService, SessaoService, TranslateService]
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: CredentialsInterceptor,
          deps: [SessaoService, SEGURANCA_CONFIGURATION],
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: DateTypeInterceptor,
          multi: true
        },
      ]
    };
  }
}
